import { supabase } from "@/integrations/supabase/client";

export const INBOX_SCOPE_CHANGED_EVENT = "inbox-scope-changed";

export type InboxScopeChangedDetail = {
  workspaceId: string;
  leadId?: string;
  reason?: "assignment" | "visibility";
};

export function inboxScopeChannelName(workspaceId: string): string {
  return `inbox-scope-${workspaceId}`;
}

function broadcastInboxScopeChanged(detail: InboxScopeChangedDetail) {
  const channel = supabase.channel(inboxScopeChannelName(detail.workspaceId), {
    config: { broadcast: { self: false } },
  });

  channel.subscribe((status) => {
    if (status !== "SUBSCRIBED") return;
    void channel.send({
      type: "broadcast",
      event: INBOX_SCOPE_CHANGED_EVENT,
      payload: detail,
    });
    supabase.removeChannel(channel);
  });
}

export function dispatchInboxScopeChanged(detail: InboxScopeChangedDetail) {
  if (typeof window !== "undefined") {
    window.dispatchEvent(new CustomEvent(INBOX_SCOPE_CHANGED_EVENT, { detail }));
  }
  broadcastInboxScopeChanged(detail);
}
